import React from 'react';
import { Link } from 'react-router-dom';
import { HeaderProps } from '../../types';
import { Button } from '../ui/Button';

export const Header: React.FC<HeaderProps> = ({ className = '' }) => {
  return (
    <header
      id="hero"
      className={`relative text-center py-20 md:py-32 px-4 overflow-hidden ${className}`}
      style={{
        background: 'radial-gradient(circle at top, rgba(34, 197, 94, 0.15), transparent 50%)'
      }}
    >
      <div className="relative z-10">
        <h1 className="text-4xl md:text-6xl font-extrabold text-white tracking-tight">
          The Definitive D8 Directory
        </h1>
        <p className="mt-4 max-w-3xl mx-auto text-lg md:text-xl text-gray-300">
          Your portal to authenticated, reviewed, and validated online D8 products and hemp flower. We did extensive research spanning over 260 sources.
        </p>
        <h2 className="mt-8 max-w-2xl mx-auto text-base md:text-lg text-green-300 font-semibold">
          Our initial searches turned up hundreds. But after going through our proprietary validation and ranking system, these were the 47 that made the cut.
        </h2>
        <div className="mt-6">
          <Link
            to="/editor"
            className="text-green-400 hover:text-green-300 font-medium transition-colors duration-300 inline-block underline"
          >
            Read the Research Report and learn about our ranking criteria →
          </Link>
        </div>
        <div className="mt-8">
          <Button
            href="#directory"
            size="lg"
          >
            Explore The Directory
          </Button>
        </div>
      </div>
      
      {/* Scroll down indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#directory" aria-label="Scroll down">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </a>
      </div>
    </header>
  );
};
